import styles from './Spinner.module.scss';

type SpinnerProps = {
  size?: string;
};

const Spinner = ({ size }: SpinnerProps) => {
  return (
    <svg
      className={styles.spinner}
      width={size || '65px'}
      height={size || '65px'}
      viewBox="0 0 66 66"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        className={styles.path}
        fill="none"
        strokeWidth="6"
        strokeLinecap="round"
        cx="33"
        cy="33"
        r="30"
      ></circle>
    </svg>
  );
};
export default Spinner;
